<template>
  <div>
    <div
      class="
        text-sm
        cursor-pointer
        mb-2
        btn-radius
        p-3
        border
        hover:border-primary
        bg-secondary-light
        text-secondary-invert
        mailform-pages-tag-wrapper
      "
      :class="[
        activeElement.id == item.id
          ? 'border-primary'
          : 'border-transparent',
        item.is_draft ? 'bg-secondary-light' : 'bg-secondary',
      ]"
      @click="activateElement(item)"
      :data-default="item.is_default"
    >
      <div class="flex justify-between items-center relative">
        <div class="w-56 flex flex-1 items-center justify-between">
          <div class="flex flex-1 w-full">
            <div
              class="truncate w-full"
            >
              {{ item.name }}
            </div>
          </div>
          </div>
          <div
            class="absolute bg-primary px-1 rounded-tr rounded-bl text-xs"
            v-if='item.default'
            style="top: -12px; right: -12px; font-size: 10px;"
          >
            {{ $t('frontend_account_default') }}
          </div>
        <drop-menu
          v-if="activeElement.id == item.id"
          :menuItems="getMenuItems(item)"
          dropMenuClass="mt-0 absolute right-0 z-10"
          variant="dark"
          small
          smallIcon
        >
        </drop-menu>
      </div>
      <div
        v-if="item.is_default == 0"
        class="flex justify-between items-center mt-3"
      >
        <label class="font-semibold opacity-75">{{
          item.is_draft ? $t('frontend_groovemail_draft') : $t('frontend_groovemail_live')
        }}</label>
        <gd-toggle
          bgClass="bg-grey-300"
          :value="!item.is_draft"
          :title="item.is_draft ? $t('frontend_groovemail_make_live') : $t('frontend_groovemail_send_draft')"
          @change="changeDraftStatus"
        />
      </div>
    </div>
    <div v-if="editMode" class="mb-8">
      <text-input
        class="mb-3"
        variant="dark"
        v-model="presetName"
      />
      <div class="flex gap-2">
        <gd-button 
          variant="primary"
          size="sm"
          @click="updatePreset"
        >
          {{ $t('frontend_update') }}
        </gd-button>
        <gd-button
          variant="dark"
          size="sm"
          @click="editMode = false"
        >
          {{ $t('frontend_cancel') }}
        </gd-button>
      </div>
    </div>

  </div>
</template>
<script>
import DropdownIcon from '@groovepages/gd-ui-kit/assets/dropdown-dots.svg';
import { VTooltip } from 'v-tooltip';

export default {
  name: 'Tag',
  props: {
    item: {},
    activeElement: {},
  },
  data() {
    return {
      presetName: this.item.name,
      editMode: false,
      DropdownIcon,
    };
  },
  components: {
    //
  },
  directives: { tooltip: VTooltip },
  watch: {
    item: {
      handler(newVal) {
        this.presetName = newVal.name;
      }
    },
  },
  methods: {
    activateElement(item) {
      this.$emit("activateElement", item);
    },

    // updated the template name
    async updatePreset() {
      // create template object
      const preset = Object.assign({}, this.item);

      // update template name
      preset.name = this.presetName;

      // update template in store
      await this.$store.dispatch('forms/updatePreset', preset);

      // close edit mode
      this.editMode = false;
    },


    getMenuItems(item) {
      const arr = [
        {
          text: this.$t('frontend_rename'),
          callback: () => {
            this.editMode = true;
          },
        },
        {
          text: this.$t('frontend_clone'),
          callback: () => {
            this.$store.dispatch('forms/addPreset', { preset: item, name: `${item.name} clone`});
          },
        },
      ];

      if (!item.default) {
        arr.push({
          text: this.$t('frontend_set_as_default'),
          callback: () => {
            this.$store.dispatch('forms/setPresetAsDefault', item);
          },
        });
      }
      if (!item.default) {
        arr.push({
          text: this.$t('frontend_delete'),
          callback: () => {
            this.$emit("deleteElement", item);
          },
        });
      }

      return arr;
    },
  },
};
</script>
